import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-aria-menubutton';
import classnames from 'classnames';
import ArchiveImage from 'Components/icons/ArchiveImage/ArchiveImage';
import CheckIcon from 'Components/icons/check-icon/CheckIcon.jsx';
import DOMPurify from "dompurify";
import { COLORS } from "Constants/BIDashboardConstants"

const WithIcon = ({ item, selectedItem, isArchiveImage }) => (
  <div
    className={isArchiveImage ? null : 'select-menu-with-icon-wrapper'}
    style={isArchiveImage && { alignItems: 'center', display: 'flex' }}
  >
    {isArchiveImage ? <ArchiveImage /> : null}
    <div style={isArchiveImage && { fontSize: 13, marginLeft: 15, color: COLORS.oneGp.globalBlue }}>
      {item.text}
    </div>
    {selectedItem === item ? <CheckIcon /> : null}
  </div>
);

WithIcon.propTypes = {
  item: PropTypes.object.isRequired,
  selectedItem: PropTypes.object,
  isArchiveImage: PropTypes.bool,
};

WithIcon.defaultProps = {
  selectedItem: {},
};

const WithFilter = ({ item }) => (
  <div>
    <strong>Filter By:</strong>
    {item.text}
  </div>
);

WithFilter.propTypes = {
  item: PropTypes.object.isRequired,
};


const MenuItemsElements = ({ doclabelClass, dataList, name, selectedItem, type, options, translations, isArchiveImage }) => {
  return (
    <div>
      {dataList.map((item, index) => {
        const itemcolor = item.color !== undefined ? item.color : 'currentColor';
        const variations = {

          withIcon: <WithIcon item={item} selectedItem={selectedItem} isArchiveImage={isArchiveImage} />,
          withFilter: <WithFilter item={item} selectedItem={selectedItem} />,
        };
        const key = `${item.value}-${index}`;
        const selectMenuItemInnerClass = `select-menu-item-inner ${doclabelClass}`;
        const isSelected = selectedItem && selectedItem.value === item.value;
        const itemClass = classnames(`select-menu-option ${doclabelClass}`, {
          'is-selected': isSelected,
        });
        const __ALL_TAKE_ACTIONS__ = ["Notify & Request Docs",'Write off or Goodwill','Request Additional Info','Respond to Issuer',
        'Unable to Defend/Pursue','Close Case','Unpend Case','Pend Case','Transfer Case','Add Case Notes','Pursue Case Filing','Upload Document',
        'Create Document','Unable to Fulfill','Respond to Card Brand','Deny','Accept','Challenge','Unable to Fulfill Request','Fulfill Request','Request Issuer Docs',];
        const isTakeAction = (item) => {
          if (__ALL_TAKE_ACTIONS__.includes(item.value))
          return true;
          else
          return false;
        }
        return (
          <li className="select-menu-options-wrapper" key={key} style={{ color: itemcolor }}>
            <MenuItem
              style={{ padding: doclabelClass != '' && '12px 16px' }}
              className={itemClass}
              value={item.value}
              text={item.text}
              data-name={name}
            >
            {isTakeAction(item)?<div className={selectMenuItemInnerClass} id = {item.value.split(" ").join("")}>
              {type ? <div>{variations[type]}</div> : <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.text) }} />}
              </div>:
              <div className={selectMenuItemInnerClass}>
                {type ? <div>{variations[type]}</div> : <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.text) }} />}
              </div>}
              {options ?
                <div className="select-menu__more-options">
                  <span className="edit">{translations.edit}</span>
                  <span className="divider">|</span>
                  <span className="delete">{translations.delete}</span>
                </div> : ''
              }
            </MenuItem>
          </li>
        );
      })}
    </div>
  );
};

MenuItemsElements.propTypes = {
  dataList: PropTypes.array.isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  selectedItem: PropTypes.object,
  type: PropTypes.string,
  options: PropTypes.bool,
  translations: PropTypes.object,
  doclabelClass: PropTypes.string,
};

MenuItemsElements.defaultProps = {
  name: 0,
  selectedItem: {},
  type: '',
  options: false,
  translations: {},
  doclabelClass: '',
};

export default MenuItemsElements;
